// src/components/ui/Button.jsx
import React from 'react';

const Button = ({ 
  children, 
  onClick, 
  type = 'button', 
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  disabled = false,
  className = '',
  ...props 
}) => {
  
  // inline-flex + items-center centers label/icon within the min-h floor
  // below, which exists purely so every size hits a ~44px touch target -
  // the visual padding alone (small/medium) would otherwise land at
  // 32-40px tall.
  const baseClasses = 'inline-flex items-center justify-center font-medium rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 transition-all active:scale-[0.98]';

  const variantClasses = {
    primary: 'bg-amber-600 text-white hover:bg-amber-700 shadow-sm',
    secondary: 'bg-gray-100 text-gray-900 hover:bg-gray-200',
    outline: 'bg-transparent border border-amber-600 text-amber-600 hover:bg-amber-50',
    text: 'bg-transparent text-amber-600 hover:text-amber-700 hover:underline'
  };

  const sizeClasses = {
    small: 'min-h-11 py-1.5 px-4 text-sm',
    medium: 'min-h-11 py-2.5 px-5 text-sm',
    large: 'min-h-11 py-3 px-7 text-base'
  };

  const classes = `
    ${baseClasses}
    ${variantClasses[variant]}
    ${sizeClasses[size]}
    ${fullWidth ? 'w-full' : ''}
    ${disabled ? 'opacity-50 cursor-not-allowed active:scale-100' : ''}
    ${className}
  `;
  
  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
